import React, { ReactNode } from 'react'
import { useTranslation } from '../../useTranslation'

export type InputError =
    | {
          key: string
          values: object
      }
    | string

interface InputProps {
    label?: string
    hideLabel?: boolean
    children?: ReactNode
    error?: InputError
    info?: string
    required?: boolean
    style?: React.CSSProperties
    className?: string
}

const Input: React.FC<InputProps> = ({ label, hideLabel, children, error, required = false, style, info, className }) => {
    const { t } = useTranslation()
    return (
        <div className={'text-left'.concat(` ${className}` || '')} style={style}>
            {hideLabel || label == null ? null : (
                <label className="leading-none text-base font-light text-custom_yellow mb-2 block max-tablet:text-sm">
                    {label == '' ? '\u00A0' : label} {required && '*'}
                </label>
            )}
            {children && <div className="">{children}</div>}
            {info && <p className="text-blue-500 font-light pt-2 text-sm;">{info}</p>}
            {error && typeof error === 'string' && <p className="ringo-error">{error}</p>}
            {error && typeof error !== 'string' && <p className="ringo-error">{(t as any)(error.key, error.values)}</p>}
        </div>
    )
}

export default Input
